import { render, staticRenderFns } from "./TicketPayConfirm.vue?vue&type=template&id=299df5b7&scoped=true"
import script from "./TicketPayConfirm.vue?vue&type=script&lang=js"
export * from "./TicketPayConfirm.vue?vue&type=script&lang=js"
import style0 from "./TicketPayConfirm.vue?vue&type=style&index=0&id=299df5b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299df5b7",
  null
  
)

export default component.exports